import AdminText from './AdminText';
import React, { useState } from 'react';
import { translateAdmin } from '../../utils/adminTranslations';
import axios from 'axios';
import { apiUrl } from '../../config';
import { formatDateTime, formatDateTimeToTM } from '../../utils/dynamic';

// const DownloadReport = () => {
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");

//   const handleDownload = async () => {
//     if ((!startDate && endDate) || (startDate && !endDate)) {
//       alert("Пожалуйста, выберите обе даты!");
//       return;
//     }
//     try {
//       // Отправка GET-запроса на сервер
//       const token = localStorage.getItem('accessToken');
//       const response = await axios.get(`${apiUrl}/api/sys/generate-report/bookings`, {
//         params: {
//           type: 'day', // или 'week', 'month'
//           start_date: startDate, // Пример даты
//           end_date: endDate, // Пример даты
//         },
//         responseType: 'blob', // Важно для правильной обработки файла
//         headers: {
//           Authorization: `Bearer ${token}`,
//         },
//       });
//       // Создание ссылки для скачивания файла
//       const fileURL = window.URL.createObjectURL(new Blob([response.data]));
//       const link = document.createElement('a');
//       link.href = fileURL;
//       link.setAttribute('download', `report_${startDate}_${endDate}.xlsx`); // Имя файла
//       document.body.appendChild(link);
//       link.click();

//       // Убираем ссылку после скачивания
//       document.body.removeChild(link);
//     } catch (error) {
//       alert("Нет бронирований")
//       console.error('Error downloading the file:', error);
//     }
//   };

//   return (
//     <div>
//       <div className='d-flex'>
//         <div className='dinput-block'>
//           <label htmlFor="start-date"><AdminText>Начальная дата:</AdminText></label>
//           <input
//             className='dinput'
//             type="date"
//             id="start-date"
//             value={startDate}
//             onChange={(e) => setStartDate(e.target.value)}
//           />
//         </div>
//         <div className='dinput-block'>
//           <label htmlFor="end-date"><AdminText>Конечная дата:</AdminText></label>
//           <input
//             className='dinput'
//             type="date"
//             id="end-date"
//             value={endDate}
//             onChange={(e) => setEndDate(e.target.value)}
//           />
//         </div>
//       </div>
//       <button className='system-booking-table-btn system-booking-table-btn-view' onClick={handleDownload}><AdminText>Получить отчет</AdminText></button>
//     </div>
//   );
// };

// export default DownloadReport;

const DownloadReport = () => {
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [reportTypeBooking, setReportTypeBooking] = useState("all");
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [currentPrinter, setCurrentPrinter] = useState(null);
  const [currentPosition, setCurrentPosition] = useState(null);

  const headers = [
    "Номер брони",
    "Тип комнаты",
    "Стоимость номера за 1 сутки, ТМТ / $",
    "Номер или бронь",
    "Сумма за бронь",
    "Доплата",
    "Сумма за номер TMT",
    "Сумма за номер $",
    "Тип оплаты",
    "Плательщик",
    "Номер телефона",
    "Дата оплаты",
    "Дата въезда",
    "Дата выезда"
  ];

  const handleFetchReport = async () => {
    if ((!startDate && endDate) || (startDate && !endDate)) {
      alert(translateAdmin("Пожалуйста, выберите обе даты!"));
      return;
    }
    try {
      setLoading(true);
      const token = localStorage.getItem('accessToken');
      const response = await axios.get(`${apiUrl}/api/sys/generate-report/bookings`, {
        params: { type: 'day', start_date: startDate, end_date: endDate, type_booking: reportTypeBooking },
        headers: { Authorization: `Bearer ${token}` },
      });

      const data = response.data;
      if (!data || !data.data || data.data.length === 0) {
        alert(translateAdmin("Нет бронирований за выбранный период."));
        return;
      }


      setCurrentPrinter(data.full_name);
      setCurrentPosition(data.position);
      setReportData(data);
      setShowModal(true);
    } catch (err) {
      alert(err?.response?.data?.request?.message || translateAdmin("Произошла ошибка при получении отчета."));
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = () => {
    if (!reportData) return;

    // Берем только таблицу из модалки
    const printContents = document.getElementById('report-table').outerHTML;

    // Создаем iframe для печати, чтобы не менять страницу
    const iframe = document.createElement('iframe');
    iframe.style.position = 'fixed';
    iframe.style.right = '0';
    iframe.style.bottom = '0';
    iframe.style.width = '0';
    iframe.style.height = '0';
    iframe.style.border = '0';
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(`
    <html>
      <head>
        <style>
          @media print {
            @page { size: A4 portrait; margin: 5mm; }
            body { font-family: Arial, sans-serif; margin:0; padding:0; }
            table { width: 100% !important; border-collapse: collapse; border-spacing: 0; page-break-inside: auto; }
            th, td { border: 1px solid #585858; padding: 2px 2px; text-align: left; word-wrap: break-word; }
            th { background-color: #f0f0f0; }
            thead { display: table-header-group; }
            tr { page-break-inside: avoid; }
          }
          table { width: 100%; border-collapse: collapse; border-spacing: 0; margin: 0 auto; }
          th, td { border: 1px solid #585858; padding: 2px 2px; text-align: left; font-size: 10px; }
          th { background-color: #f0f0f0; }
          .current-pos-print { display: flex; justify-content: space-between; padding: 0 100px; }
        </style>
      </head>
      <body>
        ${printContents}
      </body>
    </html>
  `);
    doc.close();

    iframe.contentWindow.focus();
    iframe.contentWindow.print();

    // Убираем iframe после печати
    setTimeout(() => document.body.removeChild(iframe), 1000);
  };

  return (
    <div>
      <div className='d-flex'>
        <div className='dinput-block'>
          <label><AdminText>Начальная дата:</AdminText></label>
          <input type="date" value={startDate} onChange={e => setStartDate(e.target.value)} className='dinput' />
        </div>
        <div className='dinput-block'>
          <label><AdminText>Конечная дата:</AdminText></label>
          <input type="date" value={endDate} onChange={e => setEndDate(e.target.value)} className='dinput' />
        </div>
      </div>
      <select className='dinput-block dinput' onChange={e => setReportTypeBooking(e.target.value)} >
        <option value="all"><AdminText>Все</AdminText></option>
        <option value="0"><AdminText>Онлайн</AdminText></option>
        <option value="1"><AdminText>Бланк</AdminText></option>
        <option value="2"><AdminText>Чек</AdminText></option>
        <option value="4"><AdminText>Перечисление</AdminText></option>
      </select>

      <button onClick={handleFetchReport} disabled={loading} className='system-booking-table-btn system-booking-table-btn-view'>
        {loading ? translateAdmin("Загрузка...") : translateAdmin("Получить отчет")}
      </button>

      {showModal && reportData && (
        <div className="modal-overlay booking-report-modal">
          <div className="modal-content">
            <div className="table-container" style={{ padding: "5px" }} id="report-table">
              {((startDate !== "" && endDate !== "") && (startDate === endDate)) && 
                <h2>Отчет бронирований об оплате за {startDate} число</h2>
              }
              {(startDate !== endDate) && 
                <h2>Отчет бронирований об оплате с {startDate} до {endDate} числа</h2>
              }
              {(startDate === "" && endDate === "") &&
                <h2>Отчет бронирований об оплате за {formatDateTimeToTM(null, false, 5)} число</h2>
              }
              <div className="totals">
                <p><strong>Общая сумма брони:</strong> {reportData.totals.total_booking}</p>
                <p><strong>Общая сумма за доп. гостей:</strong> {reportData.totals.total_extra_guests}</p>
                <p><strong>Общая сумма за номер TMT:</strong> {reportData.totals.total_room_tmt}</p>
                <p><strong>Итоговая сумма TMT:</strong> {reportData.totals.total_tmt}</p>
                <p><strong>Общая сумма за номер $:</strong> {reportData.totals.total_room_usd}</p>
              </div>
              <table>
                <thead style={{ fontSize: "14px" }}>
                  <tr>{headers.map(h => <th key={h}>{h}</th>)}</tr>
                </thead>
                <tbody style={{ fontSize: "14px" }}>
                  {reportData.data.map((row, i) => (
                    <tr key={i}>
                      <td>{row.book_number}</td>
                      <td>{row.room_type}</td>
                      <td>{row.price_per_night}</td>
                      <td>{row.booking_or_room}</td>
                      <td>{row.amount_booking}</td>
                      <td>{row.extra_charge}</td>
                      <td>{row.amount_room_tmt}</td>
                      <td>{row.amount_room_usd}</td>
                      <td>{row.payment_status} <span className={row.boldstyle_for_payment_type}>{row.payment_type && `/ ${row.payment_type}`}</span></td>
                      <td>{row.payer || ''}</td>
                      <td>{row.phone_number || ''}</td>
                      <td>{formatDateTime(row.payment_date)}</td>
                      <td>{formatDateTime(row.checkin_date)}</td>
                      <td>{formatDateTime(row.checkout_date)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className='d-flex just-content-sb current-pos-print'>
                {currentPosition &&
                  <h3 className='current-position'>{currentPosition}:</h3>
                }
                <h3 className='current-printer'>{currentPrinter}</h3>
              </div>
            </div>
            <div className="modal-buttons">
              <button onClick={handlePrint} className='system-booking-table-btn system-booking-table-btn-view'><AdminText>Печать</AdminText></button>
              <button onClick={() => setShowModal(false)} className='system-booking-table-btn system-booking-table-btn-cancel'><AdminText>Закрыть</AdminText></button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DownloadReport;
